// @flow
import React from 'react';
import type { Node } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import appActions from '../../actions/appActions';

import ListSubheader from '@material-ui/core/ListSubheader';
import {FormattedMessage} from "react-intl";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import Box from "@material-ui/core/Box";


const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingRight: theme.spacing(1),
        fontSize: theme.typography.h6.fontSize,
        color: theme.palette.text.primary,
    },
}));

type Props = $ReadOnly<{
    title: Node
}>;

function Header({ title }: Props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const closeSidebar = () => dispatch(appActions.setSection(null));

    return (
        <React.Fragment>
            <Box my={1}>
                <ListSubheader classes={{ root: classes.root }}>{title}
                    <IconButton onClick={closeSidebar}>
                        <CloseIcon />
                    </IconButton>
                </ListSubheader>
            </Box>
            <Divider />
        </React.Fragment>
    );
}

export default Header;